import { ApiServiceBase } from '../api-service-base';

export class ProductsService extends ApiServiceBase {
  constructor() {
    super('shops');
  }

  private getUrl({ shopId }: { shopId: number }): string {
    return `${this.serviceBaseUri}/${shopId}/data-insights/metadata`;
  }

  async getProductsMetadata({ shopId }: { shopId: number }): Promise<string[]> {
    const url = this.getUrl({ shopId });
    const response = await this.httpService.get({ url });
    return response.data;
  }
}

export const productsService = new ProductsService();
